/**
 * Monaco's TS/JS language services only run on the `typescript`/`javascript` language ids, so
 * TSX/JSX files use those ids (the TS worker still parses JSX from the `.tsx`/`.jsx` URI).
 */
const MONACO_ID: Record<string, string> = { tsx: "typescript", jsx: "javascript" };

/** The Monaco language id for one of ours. Kept apart from highlighting.ts, which is lazy. */
export function monacoLanguageId(languageId: string): string {
  return MONACO_ID[languageId] ?? languageId;
}
